export const AppAccess = {
  ApiAccess: 'ApiAccess',
  MultiCompany: 'MultiCompany',
  DisallowOldQuoting: 'DisallowOldQuoting',
  NoClassicFeatures: 'NoClassicFeatures',
  SalesStores: 'SalesStores',
};
